export default __webpack_public_path__ + "static/media/banner-1.c71892a3.jpg";